import DeleteIcon from '@mui/icons-material/Delete';
import MicIcon from '@mui/icons-material/MicNoneOutlined';
import StopIcon from '@mui/icons-material/StopCircleOutlined';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import IconButton from 'components/IconButton/IconButton';
import useAudioRecorder from 'hooks/useAudioRecorder';
import React, { useEffect } from 'react';
import AudioPlayer from '../modules/phoneapp/components/AudioPlayer';

function formatMinutes(minutes) {
  return minutes < 10 ? `0${minutes}` : minutes;
}

function formatSeconds(seconds) {
  return seconds < 10 ? `0${seconds}` : seconds;
}

const AudioRecorder = ({
  label = 'Record Voicemail',
  onChange,
  hasError,
  fullWidth,
}) => {
  const { recorderState, cancelRecording, saveRecording, startRecording } =
    useAudioRecorder();
  const { recordingMinutes, recordingSeconds, initRecording, audio } =
    recorderState;

  useEffect(() => {
    if (onChange) {
      onChange(audio);
    }
  }, [audio]);

  const onStop = () => {
    saveRecording();
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        borderColor: hasError ? 'error.main' : 'divider',
        height: 50,
        padding: 1,
        maxWidth: fullWidth ? '100%' : 290,
      }}
    >
      {initRecording ? (
        <IconButton
          title="Stop Recording"
          color="error"
          icon={<StopIcon />}
          onClick={onStop}
        />
      ) : (
        !audio && (
          <IconButton
            title="Record"
            color="primary"
            icon={<MicIcon />}
            onClick={startRecording}
          />
        )
      )}
      {initRecording ? (
        <Typography color="primary.main">
          <span>{formatMinutes(recordingMinutes)}</span>
          <span>:</span>
          <span>{formatSeconds(recordingSeconds)}</span>
        </Typography>
      ) : (
        !audio && (
          <Typography sx={{ ml: 1 }} color="primary.main">
            {label}
          </Typography>
        )
      )}
      {audio && (
        <AudioPlayer
          fullWidth={fullWidth}
          url={window.URL.createObjectURL(audio)}
        />
      )}
      {!initRecording && audio && (
        <Box>
          <IconButton
            title="Start over"
            color="error"
            icon={<DeleteIcon />}
            onClick={cancelRecording}
          />
        </Box>
      )}
    </Paper>
  );
};

export default AudioRecorder;
